import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { UserManager } from 'oidc-client';

interface UserState {
  idToken: string | null;
  accessToken: string | null;
  isLoading: boolean;
  error: string | null;
}

export const initialState: UserState = {
  idToken: null,
  accessToken: null,
  isLoading: false,
  error: null,
};

function startLoading(state: UserState) {
  state.isLoading = true;
}

export const fetchUser = createAsyncThunk('fetchUser', async (um: UserManager) => {
  const response = await um
    .signinSilent()
    .then((u) => {
      um.storeUser(u);
      return {
        idToken: u.id_token,
        accessToken: u.access_token,
      };
    })
    .catch((e) => {
      return null;
    });

  return response;
});

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchUser.pending, startLoading);
    builder.addCase(fetchUser.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.error = null;
      if (!payload) return;
      if (payload.idToken) state.idToken = payload.idToken;
      state.accessToken = payload.accessToken;
    });
    builder.addCase(fetchUser.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message || 'Fetching user failed';
    });
  },
});

export default userSlice.reducer;
